/**
 * Outcome of a wasted or fulfilled slot attempt, as crystallized on the
 * treatment plan. `DeliveryAttempt` is the immutable delivery-fact aggregate
 * (TM-9064): a wasted no-show creates one with outcome `NO_SHOW`, a
 * late patient cancellation creates one with outcome `LATE_CANCELLATION`
 * (slice 5), and a successful confirmation creates one with outcome
 * `DELIVERED` so `deliveredCount` derives from this collection.
 */
export var DeliveryAttemptOutcome;
(function (DeliveryAttemptOutcome) {
    DeliveryAttemptOutcome["DELIVERED"] = "delivered";
    DeliveryAttemptOutcome["NO_SHOW"] = "no_show";
    DeliveryAttemptOutcome["LATE_CANCELLATION"] = "late_cancellation";
})(DeliveryAttemptOutcome || (DeliveryAttemptOutcome = {}));
//# sourceMappingURL=delivery-attempt-outcome.enum.js.map